import styled from '@emotion/styled';
import { v4 as uuidv4 } from 'uuid';

import { SalesforceIframe } from '@/components/common/salesforce/SalesforceIframe';
import { Section } from '@/components/layout/Section';

interface SalesforceProps {
  formName?: string;
  formType: string;
  campaignID?: string;
  DYId?: string;
}

export const Salesforce = ({
  formName,
  formType,
  campaignID,
  DYId,
}: SalesforceProps) => {
  const uniqid = uuidv4();
  const getFormType = () => {
    switch (formType) {
      case 'contactSales':
        return 'https://mcn8786jzb4fjh-0qn5f029n9x4q.pub.sfmc-content.com/4mdpav5c2wo';
      case 'B2C':
        return 'https://mcn8786jzb4fjh-0qn5f029n9x4q.pub.sfmc-content.com/0wjke0gmcuo';
      case 'contentDownload':
        return 'https://mcn8786jzb4fjh-0qn5f029n9x4q.pub.sfmc-content.com/l2byuwydjbo';
      case 'event':
        return 'https://mcn8786jzb4fjh-0qn5f029n9x4q.pub.sfmc-content.com/pviv4n0i0zk';
      default:
        return 'https://mcn8786jzb4fjh-0qn5f029n9x4q.pub.sfmc-content.com/4mdpav5c2wo';
    }
  };
  return (
    <SalesforceSection className="salesforce" breakout>
      <SalesforceIframe
        src={getFormType()}
        formName={formName}
        campaignID={campaignID}
        iframeID={uniqid}
        DYId={DYId}
      />
    </SalesforceSection>
  );
};

const SalesforceSection = styled(Section)`
  margin-top: var(--space-block-md);
  padding-left: var(--space-block-lg);
  padding-right: var(--space-block-lg);
`;
